import { instance } from '@/utils/http.js'

export const loginApi = function (data) {
  return instance({
    url: '/api/v1/login',
    method: 'post',
    data
  })
}